<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title=this.setSectionTitle()
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_detail") }}</h5>
          <p class="mb-0">{{ $t("introduction_job_detail") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("information") }} :</strong> {{ $t("information") }}</li>
            <li><strong>{{ $t("sites") }} :</strong> {{ $t("sites_detail") }}</li>
            <li><strong>{{ $t("users") }} :</strong> {{ $t("users_detail") }}</li>
            <li><strong>{{ $t("document") }} :</strong> {{ $t("document_detail") }}</li>
            <li><strong>{{ $t("conversation") }} :</strong> {{ $t("conversation_detail") }}</li>
            <li><strong>{{ $t("notes") }} :</strong> {{ $t("notes_detail") }}</li>
            <li><strong>{{ $t("revire_&_feedback") }} :</strong> {{ $t("review_and_feedback_form") }}</li>

          </ul>
        </div>
      </div>
    </div>
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
    <job-bid
      v-if="isAddEditModalActive"
      :table-id="tableId"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>
<script>
import { JOB_OWNER } from "../../../../../Config/ApiUrl";
import { axiosGet } from "../../../../../Helpers/AxiosHelper";
import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Tabs",
  components: { CopyButton },
  props: {
    id: Number,
    sectionTitle: String
  },
  data() {
    return {
      instructionShow: false,
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Information",
          component: "job-info",
          permission: true,
          props: {id:this.id},
        },
        {
          icon: "link",
          name: "Sites",
          component: "job-site",
          permission: true,
          props: {id:this.id, close:this.instructionClose}
        },
        {
          icon: "users",
          name: "Users",
          component: "job-users",
          permission: true,
          props: {id:this.id},
        },
        {
          icon: "file-text",
          name: "Document",
          component: "job-document",
          permission: true,
          props: {id:this.id},
        },
        {
          icon: "message-square",
          name: "Conversation",
          component: "job-chat",
          permission: true,
          props: {id:this.id},
        },

        {
          icon: "message-circle",
          name: "Notes",
          component: "job-notes",
          permission: true,
          props: {id:this.id},
        },
        // {
        //   icon: "users",
        //   name: "Bids",
        //   component: "job-bids",
        //   permission: true,
        // },
         {
          icon: "message-circle",
          name: "Review & Feedback",
          component: "job-review",
          permission: "",
          props: {id:this.id},
        },
      ],
    };
  },
  methods: {
    setSectionTitle(){
      let title = this.sectionTitle??'job_management';
      return this.$t(title);
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose(value) {
      this.instructionShow = value ?? false;
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
    themeMode() {
      return this.$store.state.theme;
    },
  },

  mounted() {

    axiosGet(JOB_OWNER + "/" + this.id)
      .then((res) => {
        this.tabsHorizontal.forEach((element) => {
          if (element.name == "Users") {
            element.permission = res.data.status;
          }
          if (element.name == "Bids") {
            element.permission = res.data.status;
          }
        });
      })
      .catch((error) => {
        
      });
  },
};
</script>
